// extracted by mini-css-extract-plugin
export default {"container":"common-routes_container__qW2TY","narrow":"common-routes_narrow__k3H5C","content":"common-routes_content__qHlZ9","title":"common-routes_title__w8Aqb"};